import { render, staticRenderFns } from "./barraSuperior.vue?vue&type=template&id=3386036c&scoped=true"
import script from "./barraSuperior.vue?vue&type=script&lang=js"
export * from "./barraSuperior.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3386036c",
  null
  
)

export default component.exports